var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"GetBBRData"},[_c('div',{staticClass:"LoadingWrap"},[_c('Circular',{attrs:{"size":"medium"}})],1),_c('span',[_vm._v(_vm._s(_vm.mixWB('GETTING_BBR_INFO')))])])}
var staticRenderFns = []

export { render, staticRenderFns }